import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as availabilityAction from '../actions/availability.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {AvailabiltyService} from '../../availabilty.service';


@Injectable()
export class AvailabilityEffect {
  constructor(private actions: Actions,
              private availabilityService: AvailabiltyService,
              private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAvailableDays: Observable<Action> = this.actions.ofType(availabilityAction.GET_AVAILABILITY)
    .map((action: availabilityAction.GetAvailability) => action.payload)
    .pipe(
      switchMap((body) => {
        return this.availabilityService.getAvailableDays(body)
          .map(res => new availabilityAction.GetAvailabilitySuccess(res))
          .catch(error => of(new availabilityAction.GetAvailabilityError(error)));
      })
    );

  @Effect()
  getAvailableFreelancers: Observable<Action> = this.actions.ofType(availabilityAction.GET_AVAILABLE_FREELANCERS)
    .map((action: availabilityAction.GetAvailability) => action.payload)
    .pipe(
      switchMap((body) => {
        return this.availabilityService.getAvailableFreelancers(body)
          .map(res => new availabilityAction.GetAvailableFreelancersSuccess(res))
          .catch(error => of(new availabilityAction.GetAvailableFreelancersError(error)));
      })
    );


}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/store/effects/availability.effect.ts